/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Test_OkInputs */

const cs_sreality_test_ok = /** @type {(inputs: Sreality_Test_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášení na Sreality uspělo`)
};

const en_sreality_test_ok = /** @type {(inputs: Sreality_Test_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sreality login succeeded`)
};

/**
* | output |
* | --- |
* | "Sreality login succeeded" |
*
* @param {Sreality_Test_OkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_test_ok = /** @type {((inputs?: Sreality_Test_OkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Test_OkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_test_ok(inputs)
	return cs_sreality_test_ok(inputs)
});